import React, { createContext } from 'react';

import { SidebarNode } from '../types';

const Empty = () => <></>;

export const SidebarNodeContext = createContext<SidebarNode>(<Empty />);

SidebarNodeContext.displayName = 'SidebarNodeContext';
